import React, { useState } from 'react';
import { Table } from 'semantic-ui-react';
import ColumnResizer from "react-column-resizer";

import { TableHeaderFilterColumn } from './FormFilterColumn';

export function TableHeaderFilter(props) {

    //To set the selected Row
    const [selectedKey, showInput] = useState(0);
    function handleClicked(e, item) {
        e.stopPropagation()
        if (item && item.key) {
            showInput(item.key);
        } else {
            showInput("no key selected");
            props.onSubmitFilter(null, null)
        }
    }

    //To Hide the all resource pane
    function headerRowClicked() {
        props.headerClickHideResourcePane()
    }
    return (
        <Table.Header >
            <Table.Row
                className="table-header table-header-filter"
                onClick={headerRowClicked} >
                {props.tableHeader && props.tableHeader
                    .filter((ft, i) => { return ft.listed })
                    .map((item, i) => {
                        return <React.Fragment key={i}>
                            <Table.HeaderCell
                                key={i}
                                width={item.style && item.style.width ? item.style.width : null}
                                style={item.key === "action" ? { width: "40px" } : { width: "auto" }}
                            >
                                {item.singleSearch || item.key === "action" ?
                                    <div className="float-left w_100" className="FilterHeader" style={{ lineHeight: "22px" }}>
                                        <TableHeaderFilterColumn
                                            filter={props.q}
                                            totalCount={props.totalCount ? props.totalCount : 0}
                                            onSubmitFilter={props.onSubmitFilter}
                                            loading={props.loading}
                                            type="Single Search"
                                            content={item.multiKey ? item.multiKey : item.key}
                                            className="float-left"
                                            item={item}
                                            filterByDate={props.filterByDate}
                                            filterByDropdown={props.filterByDropdown}
                                            filterByText={props.filterByText}
                                            filterByTextObject={props.filterByTextObject}
                                            handleClicked={handleClicked}
                                            selectedKey={selectedKey}
                                            headerName={item.name}
                                            headerKey={item.key}
                                            headerClickHideResourcePane={props.headerClickHideResourcePane}
                                            tableHeader={props.tableHeader}
                                            addColumn={props.addColumn}
                                            direction={props.direction}
                                            column={props.column}
                                        />
                                    </div>
                                    : null}
                            </Table.HeaderCell>
                            {
                                props.tableHeader.length - 1 === i ? null :
                                    <ColumnResizer className="columnResizer" minWidth={0} />
                            }
                        </React.Fragment>
                    })}
            </Table.Row>
        </Table.Header>
    );
}